import { Box, Typography } from "@mui/material";
import { hasUserCertificate } from "../../Utils/Utils";
import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { localUrlEnum } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import ExamCalendar from "./ExamCalendar";
import styles from "./CertificateExams.module.css";
import genericStyles from "../../Styles/genericStyles.module.css";
import { toast } from "react-toastify";

const CertificateExams = () => {
  const [hasCertificate, setHasCertificate] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const checkCertificate = () => {
      const certificateStatus = hasUserCertificate();
      setHasCertificate(certificateStatus);
      setLoading(false);
    };

    checkCertificate();
  }, []);

  const handleExamEnroll = () => {
    toast.success("Te-ai înscris cu succes la examen!");
  };

  if (loading) {
    return (
      <Box className={styles.container}>
        <Typography variant="h6">Loading...</Typography>
      </Box>
    );
  }

  if (!hasCertificate) {
    return <Navigate to={localUrlEnum.clientAccount} replace />;
  }

  return (
    <Box className={styles.container}>
      <Typography variant="h4" className={genericStyles.titleSection}>
        {Vocabulary.certificateExamTitle}
      </Typography>
      <Typography variant="body1" className={styles.caption}>
        {Vocabulary.certificateExamCaption}
      </Typography>
      <ExamCalendar onExamEnroll={handleExamEnroll} />
    </Box>
  );
};

export default CertificateExams;
